module.exports = __webpack_public_path__ + "img/mfmsbts.a38ba9c7.png";